import type { Dict } from 'common/utils/mixpanel/eventTriggers';

interface UserProfile {
  id?: number | string;
  firstName?: string;
  lastName?: string;
  email?: string;
}

interface NativePackageProductLike {
  identifier: string;
  price?: number;
  currencyCode?: string;
}

interface NativePackageLike {
  product?: NativePackageProductLike;
}

interface WebPackageLike {
  identifier?: string;
  rcBillingProduct?: {
    currentPrice?: {
      amountMicros?: number;
      currency?: string;
    };
  };
}

export const buildNativeMixpanelPayload = ({
  userProfileData,
  productIdentifier,
  offeringsPackages,
  trialVariant,
}: {
  userProfileData: UserProfile;
  productIdentifier: string;
  offeringsPackages: NativePackageLike[];
  /** Which offering / trial length the buyer was shown (see trialVariant.ts). */
  trialVariant?: { offering?: string; trial_days?: number };
}): Dict => {
  const matched = offeringsPackages.find(
    (pkg) => pkg?.product?.identifier === productIdentifier,
  );
  return {
    $first_name: `${userProfileData?.firstName ?? ''}`,
    $last_name: `${userProfileData?.lastName ?? ''}`,
    $distinct_id: userProfileData?.id?.toString() ?? '',
    $email: userProfileData?.email,
    $edit_type: 'Purchased App Package',
    $package: productIdentifier,
    $price: matched?.product?.price,
    $currency: matched?.product?.currencyCode,
    ...(trialVariant?.offering ? { offering: trialVariant.offering } : {}),
    ...(trialVariant?.trial_days !== undefined ? { trial_days: trialVariant.trial_days } : {}),
  };
};

export const buildWebMixpanelPayload = ({
  userProfileData,
  selectedPackage,
}: {
  userProfileData: UserProfile;
  selectedPackage: WebPackageLike;
}): Dict => {
  const amountMicros = selectedPackage?.rcBillingProduct?.currentPrice?.amountMicros;
  return {
    $first_name: `${userProfileData?.firstName ?? ''}`,
    $last_name: `${userProfileData?.lastName ?? ''}`,
    $distinct_id: userProfileData?.id?.toString() ?? '',
    $email: userProfileData?.email,
    $edit_type: 'Purchased App Package (Web)',
    $package: selectedPackage?.identifier,
    $price: amountMicros ? amountMicros / 1000000 : 0,
    $currency: selectedPackage?.rcBillingProduct?.currentPrice?.currency || 'USD',
  };
};
